import React from "react"
import { Icon } from "@ncs/web-legos"
import { socialMediaList } from "../style"

export const SocialMedia: React.FC = () => (
	<div css={socialMediaList}>
		<nav>
			<h2>Social Media</h2>
			<ul>
				<li>
					<a
						href="https://www.facebook.com/nationalcarwashsolutions/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="facebook"
					>
						<Icon
							className="socialIcon"
							icon="facebook"
							family="brands"
							customColor="#00254a"
							fontSize={1}
							withContainer
							aria-hidden="true"
						/>
					</a>
				</li>
				<li>
					<a
						href="https://www.instagram.com/nationalcarwashsolutions/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="instagram"
					>
						<Icon
							className="socialIcon"
							icon="instagram"
							family="brands"
							customColor="#00254a"
							fontSize={1}
							withContainer
							aria-hidden="true"
						/>
					</a>
				</li>
				<li>
					<a
						href="https://www.linkedin.com/company/national-carwash-solutions"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="linkedin"
					>
						<Icon
							className="socialIcon"
							icon="linkedin"
							family="brands"
							customColor="#00254a"
							fontSize={1}
							withContainer
							aria-hidden="true"
						/>
					</a>
				</li>
				<li>
					<a
						href="https://www.youtube.com/channel/UC-A7544E_dtbjHBjA-qPRPA"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="youtube"
					>
						<Icon
							className="socialIcon"
							icon="youtube"
							family="brands"
							customColor="#00254a"
							fontSize={1}
							withContainer
							aria-hidden="true"
						/>
					</a>
				</li>
			</ul>
		</nav>
	</div>
)
